<template>
  <QS-scroller-box>
    <QS-column-box class="mt16 mb16 border" :column="3" :list="list" :source="source" separator=":"/>
    <contractInfoComp ref="contractInfoRef" :disabledTime="disabledTime" @uploadComplete="uploadComplete" @uploadBefore="uploadBefore"/>
    <payInfoComp ref="payInfoRef"/>
    <template slot="bottomAction">
      <el-button @click="back" size="mini">取消</el-button>
      <el-button  @click="submit" type="primary" size="mini" :loading="loading">确认续约</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
import { addEnterpriseOrderRenewal } from '@/api/domain/underLease'
import contractInfoComp from './contractInfo.vue'
import payInfoComp from './payInfo.vue'

export default {
  components: { contractInfoComp, payInfoComp },
  props: {
    orderDataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [
        { key: 'id', name: '企业租赁主订单ID' },
        { key: 'customerName', name: '客户名称' },
        { key: 'leaseRangeTime', name: '原合同起止日期' },
      ],
      source: { },
      params: {
        id: '',
        customerId: '',
        contractStartDate: '',
        contractEndDate: '',
      },
      loading: false,
      disabledTime: '', // 合同结束日期不可选范围
    }
  },
  created() {
    this.dealEntData()
  },
  methods: {
    // 处理主订单数据
    dealEntData() {
      const orderInfo = this.orderDataList[0]
      // 处理source
      this.source.id = orderInfo.id
      this.source.customerName = orderInfo.customerName
      let { contractStartDate, contractEndDate } = orderInfo
      !contractStartDate && (contractStartDate = '--')
      !contractEndDate && (contractEndDate = '--')
      this.source.leaseRangeTime = `${contractStartDate}~${contractEndDate}`
      // 如原合同有合同起止日期，则续约合同填写的合同结束日期，不得早于原合同的开始日起和结束日期
      // 如原合同无合同起止日期，则续约合同结束日期不能早于原订单创建时间
      this.disabledTime = orderInfo.contractEndDate || orderInfo.gmtCreate
      // 处理params
      Object.keys(this.params).forEach((key) => {
        this.params[key] = orderInfo[key]
      })
    },
    back() {
      this.$confirm('取消后可在「订单续约」列表继续操作订单确认流程，点击确定返回列表', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$router.back()
        this.$refreshBack(false)
      })
    },
    submit() {
      const valid = this.$refs.contractInfoRef.valid()
      if (!valid) return
      const { contractInfo } = this.$refs.contractInfoRef
      const { payInfo } = this.$refs.payInfoRef
      const contractAttachment = this.getUoloadCommonFileData(contractInfo.contractAttachment)
      const params = { ...this.params, ...contractInfo, ...payInfo, contractAttachment }
      this.loading = true
      addEnterpriseOrderRenewal(params).then((res) => {
        this.loading = false
        if (res.code !== 1) return
        this.$message.success('续约成功')
        this.$router.back()
        this.$refreshBack(true)
      })
    },
    uploadComplete() {
      this.loading = false
    },
    uploadBefore() {
      this.loading = true
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .border>div{
    margin-top: 16px;
    padding:0 16px;
    box-sizing: border-box;
}
</style>
